import './GroupInProgressWish.component.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, reduxForm, reset } from 'redux-form';

import { ERoutes } from '../../../assets/constants/routes';
import { EFormName } from '../../../config/form-names.config';
import { EGroupStateKeys } from '../../../domain/group.interface';
import { EInput } from '../../../domain/input.interface';
import {
  loadGroupMoneybox,
  resetGroup,
  submitBoughtWish,
} from '../../../store/grouplist/grouplist.actions';
import {
  formatCurrencyToNumber,
  normalizeCurrency,
} from '../../../utils/FormNormalizers';
import { required } from '../../../utils/FormValidators';
import { replacePathParams } from '../../../utils/NavigateWithParams';
import { InputFieldComponent } from '../../atoms/atoms.index';
import {
  NavbarComponent,
  NavigationMenuComponent,
} from '../../organisms/organisms.index';

function GroupInProgressWishComponent(props: any) {
  const { handleSubmit, pristine, submitting, invalid } = props;
  const groupId = props.match.params.groupId;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadGroupMoneybox(groupId));
    return () => {
      dispatch(resetGroup(EGroupStateKeys.groupMoneybox));
    };
    // eslint-disable-next-line
  }, []);

  function handleFormReset(e: any) {
    e.preventDefault();
    dispatch(reset(EFormName.CLOSE_GROUP_WISH));
    props.history.goBack();
  }

  function formSubmit(values: any) {
    const formattedValues = {
      ...values,
      purchaseAmount: formatCurrencyToNumber(values.purchaseAmount),
    };
    dispatch(submitBoughtWish(formattedValues, groupId));
  }

  return (
    <div className='page-container group-in-progress-container'>
      <NavbarComponent />
      <NavigationMenuComponent {...props} />
      <div className='title-container'>
        <div className='title-progress-bar'></div>
        <h2 className='in-progress-title'>
          <FormattedMessage id='pages.group-in-progress.wish.title' />
        </h2>
      </div>
      <div className='content-wrapper'>
        <div className='active-group-admin-form'>
          <form onSubmit={handleSubmit(formSubmit)}>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.group-in-progress.bought_wish.title' />
              </h4>
              <FormattedMessage id='pages.group-in-progress.bought_wish.placeholder'>
                {(txt: any) => (
                  <Field
                    name={'name'}
                    component={InputFieldComponent}
                    validate={[required]}
                    label={txt}
                  />
                )}
              </FormattedMessage>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.group-in-progress.money_wish.title' />
              </h4>

              <FormattedMessage id='pages.group-in-progress.money_wish.placeholder'>
                {(txt: any) => (
                  <Field
                    name={'purchaseAmount'}
                    component={InputFieldComponent}
                    validate={[required]}
                    type={EInput.TEXT}
                    label={txt}
                    normalize={(value: number | string) =>
                      normalizeCurrency(value)
                    }
                  />
                )}
              </FormattedMessage>
            </div>
            <section className='form-button-container mt-6'>
              <div className='left-wfc'>
                <button
                  className='btn-lili danger'
                  onClick={(e: any) => handleFormReset(e)}
                >
                  <FormattedMessage id='common.cancel' />
                </button>
              </div>
              <div className='right-wfc'>
                <button
                  className='btn-lili'
                  type='submit'
                  disabled={pristine || submitting || invalid}
                >
                  <FormattedMessage id='common.save' />
                </button>
              </div>
            </section>
          </form>
        </div>
      </div>
      <div className='chat-button-container'>
        <Link to={replacePathParams(ERoutes.CHAT, { groupId: groupId })}>
          <button type='button' className='btn btn-secondary btn-circle'>
            <FontAwesomeIcon icon='comment-alt' size='2x' />
          </button>
        </Link>
      </div>
    </div>
  );
}

export default reduxForm({
  form: EFormName.CLOSE_GROUP_WISH,
})(GroupInProgressWishComponent);
